const atUnprocessedRouter = {
    path: "atUnprocessed",
    name: "atUnprocessed",
    meta: {
        title: "@待处理"
    },
    component: () => import("@/pages/index/home/atUnprocessed/AtUnprocessed"),
    redirect: {
        name: "my-at-unprocessed"
    },
    children: [
        {
            path: "my-at-unprocessed",
            name: "my-at-unprocessed",
            meta: {
                title: "@待处理-列表页"
            },
            component: () => import("@/pages/index/home/atUnprocessed/List")
        },
        {
            path: "all-at-unprocessed",
            name: "all-at-unprocessed",
            meta: {
                title: "@待处理-列表页"
            },
            component: () => import("@/pages/index/home/atUnprocessed/List")
        }
    ]
};
export default atUnprocessedRouter;



// WEBPACK FOOTER //
// ./src/router/index/home/atUnprocessed.js